import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dtc-id-list-popover',
  templateUrl: './dtc-id-list-popover.component.html',
  styleUrl: './dtc-id-list-popover.component.css'
})
export class DtcIdListPopoverComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    private _router: Router
  ) {
  }

  /**
   * Navigates to
   * @param id 
   */
  navigateTo(id: string, type: string) {
    this.dialogRef.close()
    if(type === 'dtcId') {
    const navigationExtras: any = {
      queryParams: { pageType: 'caseList' },
    };
    navigationExtras.state = {
      returnTo: `vehicles/profile/${this.data?.details?.entityId}`,
    };
    this._router.navigate([`dtc/profile/${id}`], navigationExtras);
  }
 }
}
